<div class="attributes">
  <ng-container *ngFor="let attribute of attributes">

      <div class="attributes__icon-wrapper">
        <div class="attributes__icon">
          <lps-icon 
            [icon]="attribute.type | icon" 
            [color]="'#EB194B'" 
            [size]="'md'">
          </lps-icon>
        </div>

        <span class="attributes__info">
          {{ attribute.value }}
        </span>
      </div>

  </ng-container>
</div>
